__turbopack_context__.v({
  "indicator": "progress-module-scss-module__ZdjyYW__indicator",
  "progress": "progress-module-scss-module__ZdjyYW__progress",
});
